import axios from 'axios';
import { GET_PROFILE, HOST } from '../services/Utils/Url';

const authAxios = axios.create({
    baseURL: HOST,
    headers: {
        'Content-Type': 'application/json',
    },
});

const getAccessToken = () => localStorage.getItem('access_token');
const getRefreshToken = () => localStorage.getItem('refresh_token');
const setAccessToken = (token) => localStorage.setItem('access_token', token);
const setRefreshToken = (token) => localStorage.setItem('refresh_token', token);

authAxios.interceptors.request.use(
    (config) => {
        const token = getAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

authAxios.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const { config, request, response } = error;
        if (response && (response.status === 403 || response.status === 401) && !request.responseURL.includes("refresh")) {
            const newAccessToken = await refreshToken();
            if (newAccessToken) {
                config.headers['Authorization'] = `Bearer ${newAccessToken}`;
                return axios(config);
            } else {
                navigateToHome();
                return Promise.reject(error);
            }
        } else {
            navigateToHome();
            return Promise.reject(error);
        }
    }
);

const refreshToken = async (navigate) => {
    try {
        const refreshToken = getRefreshToken();
        const payload = {
            refresh_token: refreshToken
        }
        const response = await authAxios.post('token/refresh', payload);
        const { access_token, refresh_token } = response.data;
        setAccessToken(access_token);
        setRefreshToken(refresh_token);
        window.dispatchEvent(new Event('access-token-updated'));
        return access_token;
    } catch (error) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.clear();
        navigateToHome();
    }
}

const navigateToHome = () => {
    window.location.href = '/';
}

export default class Api {
    static async LoginApi(data) {
        try {
            const res = await authAxios.post('login', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async GetOtp(data) {
        try {
            const res = await authAxios.post('send_otp', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async dashboardMetrics() {
        try {
            const res = await authAxios.get('dashboard/metrics');
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }


    static async profitableStrategies() {
        try {
            const res = await authAxios.get('metrics/strategies');
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async strategiesMe() {
        try {
            const res = await authAxios.get('strategies');
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async updateTC(data) {
        try {
            const res = await authAxios.post('profile/terms/update', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async brokers() {
        try {
            const res = await authAxios.get('profile/brokers/fetch');
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async createBrokers(data) {
        try {
            const res = await authAxios.post('profile/brokers/update', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async backtestStrategy(data) {
        try {
            const res = await authAxios.post('strategy/execute', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async liveRunStrategy(data) {
        try {
            const res = await authAxios.post('engine/schedule', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async contactUs(data) {
        try {
            const res = await authAxios.post('contactus', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async publishStrategy(data) {
        try {
            const res = await authAxios.post('publish', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async results(data) {
        try {
            const res = await authAxios.post('strategy/results/runs', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async runresults(data) {
        try {
            const res = await authAxios.post('strategy/results/run-details', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async subscribeStrategy(data) {
        try {
            const res = await authAxios.post('subscribe', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async getdayrunDetaisl(data) {
        try {
            const res = await authAxios.post('strategy/results/day-details', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async subscriptions() {
        try {
            const res = await authAxios.get('profile/plan/fetch');
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async marketPlace(data) {
        try {
            const res = await authAxios.post(`marketplace`, data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async symbols(searchStr) {
        try {
            const res = await authAxios.get(`symbols/${searchStr}`);
            if (res && Object.keys(res).length > 0) {
                return res.data;
            }
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async pending() {
        try {
            const res = await authAxios.get('dashboard/pending');
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async profile() {
        try {
            const res = await authAxios.get('profile');
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async profileUpdate(payload) {
        try {
            const res = await authAxios.post('profile/update', payload);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async strategyUpdate(payload) {
        try {
            const res = await authAxios.post('strategy/details-update', payload);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async getchartofStrategy(data) {
        try {
            const res = await authAxios.post(`strategy`, { 'strategy_id': data });
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async notification(payload) {
        try {
            const res = await authAxios.post('profile/notifications/fetch', payload);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async notificationUpdate(payload) {
        try {
            const res = await authAxios.post('profile/notifications/update', payload);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async planPurchase(payload) {
        try {
            const res = await authAxios.post('profile/plan/purchase', payload);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async pnlChart(days = 30) {
        try {
            const res = await authAxios.get('dashboard/pnlboard', {
                params: { days }
            });
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async dashboardActivities() {
        try {
            const res = await authAxios.get('dashboard/activities');
            return res.data;
        } catch (error) {
            console.error('Error fetching dashboard activities:', error);
            return error.response?.data || error;
        }
    }

    static async dashboardPendingActions(data) {
        try {
            const res = await authAxios.get(`dashboard/pending/${data}`);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async saveStrategy(data, strategyId = null) {
        try {
            const url = strategyId ? `saveStrategy/${strategyId}` : 'saveStrategy';
            const method = strategyId ? 'PUT' : 'POST';
            const res = await authAxios({ method, url, data });
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async copyStrategy(data) {
        try {
            const res = await authAxios.post('strategy/copy', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }

    static async deleteStrategy(data) {
        try {
            const res = await authAxios.post('strategy/purge', data);
            return res.data;
        } catch (error) {
            return error.response?.data || error;
        }
    }
}
